export const PLAYER_MAX_HEALTH=100;
export const PLAYER_INVULNERABILITY_SECONDS=1.5;
export const BETWEEN_LEVEL_HEAL=25;

export interface PlayerDamageResult{readonly applied:boolean;readonly previous:number;readonly current:number;readonly defeated:boolean;}

export class PlayerHealth{
  private value:number;
  private invulnerability=0;
  constructor(initial=PLAYER_MAX_HEALTH,private readonly onChanged:(current:number,maximum:number)=>void=()=>{},private readonly onDefeated:()=>void=()=>{}){this.value=Math.max(0,Math.min(PLAYER_MAX_HEALTH,initial));}
  get current():number{return this.value;}
  get maximum():number{return PLAYER_MAX_HEALTH;}
  get invulnerabilityRemaining():number{return this.invulnerability;}
  get isDefeated():boolean{return this.value<=0;}
  update(deltaSeconds:number):void{this.invulnerability=Math.max(0,this.invulnerability-Math.max(0,deltaSeconds));}
  damage(amount:number):PlayerDamageResult{const previous=this.value;if(amount<=0||this.value<=0||this.invulnerability>0)return{applied:false,previous,current:this.value,defeated:this.value<=0};this.value=Math.max(0,this.value-amount);this.invulnerability=PLAYER_INVULNERABILITY_SECONDS;this.onChanged(this.value,this.maximum);const defeated=this.value===0;if(defeated)this.onDefeated();return{applied:true,previous,current:this.value,defeated};}
  healBetweenLevel():number{this.value=Math.min(PLAYER_MAX_HEALTH,this.value+BETWEEN_LEVEL_HEAL);this.onChanged(this.value,this.maximum);return this.value;}
  prepareFinalBoss():number{this.value=Math.max(75,this.value);this.onChanged(this.value,this.maximum);return this.value;}
  resetForRetry():void{this.value=PLAYER_MAX_HEALTH;this.invulnerability=0;this.onChanged(this.value,this.maximum);}
}
